import React, { useState } from 'react';
import {
    MessageContainer,
    MessageIcon,
    MessageContent,
    Flex,
    MessageHeader,
} from './BomBannerMessage.styled.jsx';
import AlertCircleOutlineWhite from 'src/assets/images/AlertCircleOutlineWhite.svg';
import warningAssets from 'src/assets/images/warning_alt.svg';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const BomBannerMessage = (props) => {
    const {
        messageTextAlign,
        messagewhiteSpace,
        mycaseHeight,
        imgHeight,
        imgWidth,
        message,
        marginTop,
        mbMarginTop,
        marginBottom,
        isFromReportUsage,
    } = props;
    const [background, setBackground] = useState('');
    const [imgSrc, setImgSrc] = useState('');

    useEffectWithErrorLogging(() => {
        setBackground(
            isFromReportUsage
                ? '#F7A800 0% 0% no-repeat padding-box'
                : '#E5057F 0% 0% no-repeat padding-box'
        );
        setImgSrc(isFromReportUsage ? warningAssets : AlertCircleOutlineWhite);
    }, []);
    const { t } = useTranslation();
    return (
        <>
            <Flex
                marginTop={marginTop}
                marginBottom={props.isCondensedView && marginBottom}
                marginLeft={
                    props.isCondensedView
                        ? props.isLanguageChanged
                            ? '6px'
                            : '5px'
                        : 0
                }
                marginRight={props.isCondensedView && '10px'}
            >
                <MessageIcon
                    mycaseHeight={mycaseHeight}
                    background={background}
                    mbMarginTop={mbMarginTop}
                >
                    <img src={imgSrc} height={imgHeight} width={imgWidth}></img>
                </MessageIcon>

                <MessageContent
                    mycaseHeight={mycaseHeight}
                    mbMarginTop={mbMarginTop}
                >
                    <MessageHeader
                        textAlign={messageTextAlign}
                        whiteSpace={messagewhiteSpace}
                        color={isFromReportUsage && '#B56409'}
                    >
                        {message}
                    </MessageHeader>
                    <MessageContainer textAlign={messageTextAlign}>
                        {isFromReportUsage
                            ? t(
                                'consignmentBilling.common.UnknownLotSerialNumberMsg'
                                
                              )
                            : t('consignmentBilling.addSearchItems.msg')}
                    </MessageContainer>
                </MessageContent>
            </Flex>
        </>
    );
};

export default BomBannerMessage;
